import React from "react";
import styles from "./Toggle.module.scss";
import classNames from "classnames";

export default ({ form, name, value: _value, toggle: _toggle, className, disabled, ariaLabel, Component = "button", pending, children, style }) => {
    let toggle = _toggle;
    let value = _value;
    if (form && name) {
        value = value || form.formState[name];
        toggle = toggle || form.wrappedHandleFormChange(name);
    }

    const circleTransform = value ? "translate(17)" : "translate(0)";

    return (
        <Component style={style} className={classNames(styles['toggle'], className, { [styles['pending']]: pending, [styles['disabled']]: disabled, [styles['active']]: !!value })} disabled={pending || disabled}
                   onClick={() => !disabled && toggle(!value)} aria-label={ariaLabel} role="switch" aria-checked={value}>
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="19" viewBox="0 0 36 19" overflow="visible">
                <defs>
                    <filter id="prefix__a" width="172.2%" height="172.2%" x="-30.6%" y="-30.6%" filterUnits="objectBoundingBox">
                        <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
                        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"/>
                    </filter>
                </defs>
                <g fill="none">
                    <path className={styles.rail} d="M6.782 3.5h22.436c3.39-.076 6.202 2.61 6.282 6-.08 3.39-2.891 6.076-6.282 6H6.782C3.392 15.576.58 12.89.5 9.5c.08-3.39 2.891-6.076 6.282-6z"/>
                    <circle className={styles.shadow} transform={circleTransform} fill="#000" cx="9.5" cy="9.5" r="9" filter="url(#prefix__a)"/>
                    <circle className={styles.thumb} transform={circleTransform} cx="9.5" cy="9.5" r="9"/>
                </g>
                {pending &&
                <circle className={classNames(styles['pending-circle'], styles['toggle-transition'])} cx={value ? "26.5" : "9.5"} style={{ transformOrigin: value ? "26.5px center" : "9.5px center" }} cy="9.5" r="5" strokeWidth="1" fill="none"/>}
            </svg>
            {children && <span>{children}</span>}
        </Component>
    );
};